import { Progress, Tooltip } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as ExcelFileIcon } from '../../assets/images/svg/i_excel_file_icon.svg';
import { ReactComponent as InfoIcon } from '../../assets/images/svg/i_info_fill.svg';
import NumberFormatView from '../../shared/components/NumberFormatView/NumberFormatView';
import { RootState } from '../../store';
import { downloadCreditReport, fetchProviderCredits } from '../../store/actions/leftSideBarAction';
import './LeftSideBar.less';

const IHXCreditUtilized = (): ReactElement => {
  const dispatch = useDispatch();
  const { creditData } = useSelector((state: RootState): any => state?.sideBarHeader);
  const {
    providerCredits = 0,
    recommendedCredits = 0,
    balance = 0,
    amountSaved = 0,
  } = creditData;

  const percentage = providerCredits * 100 / recommendedCredits;

  useEffect((): void => {
    dispatch(fetchProviderCredits());
  }, []);

  const downloadReportClickHandler = (): any => dispatch(downloadCreditReport());

  return (
    <div className="credits-utilized" id="credit-utilized-tracking">
      <p className="heading content-center font-14">
        <b className="mr-5">IHX credits utilized</b>
        <Tooltip title="1 Credit = ₹ 55">
          <InfoIcon className="ml-5" />
        </Tooltip>
      </p>
      <p className="mb-0">0 <span className="pull-right">{recommendedCredits}</span></p>
      <Progress strokeColor="#6664D7" percent={percentage} showInfo={false} />
      <p>{providerCredits} utilized and {balance} remaining</p>
      <p>Amount saved<b className="ml-5">
        <NumberFormatView amount={amountSaved} prefix={'₹ '} fixedDecimalScale={true} />
      </b></p>
      <p className="heading content-center download" id="credit-utilized-tracking" onClick={downloadReportClickHandler}>
        <ExcelFileIcon /> <a>Download Report</a>
      </p>
    </div>
  );
};

export default IHXCreditUtilized;
